/**
 * Device detection utilities
 */

/**
 * Detects if the current device is an iOS device (iPhone, iPad, or iPod)
 * @returns true if the device is iOS-based
 */
export const isIOSDevice = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent = window.navigator.userAgent.toLowerCase();
  
  // Check for iOS devices
  return /iphone|ipad|ipod/.test(userAgent);
};

/**
 * Detects if the current device is a mobile device
 * @returns true if the device is mobile
 */
export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent = window.navigator.userAgent.toLowerCase();
  
  // Check for mobile devices
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);
};
